import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { PERMISSIONS } from 'constants/permissions';
import { ADMIN_ROUTES } from 'constants/routes';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.suppliers.general,
        label: 'General',
        permission: PERMISSIONS.suppliers.tabs.general.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.suppliers.priceLists,
        label: 'Pricelist',
        permission: PERMISSIONS.suppliers.tabs.priceList.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.suppliers.communicationHub,
        label: 'Communication Hub',
        permission: PERMISSIONS.suppliers.tabs.communicationHub.read,
        id: '3',
      },
      {
        path: ADMIN_ROUTES.suppliers.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.suppliers.tabs.task.read,
        id: '4',
      },
      {
        path: ADMIN_ROUTES.suppliers.shipping,
        label: 'Shipping',
        permission: PERMISSIONS.suppliers.tabs.shipping.read,
        id: '5',
      },
      {
        path: ADMIN_ROUTES.suppliers.pricing,
        label: 'Pricing',
        permission: PERMISSIONS.suppliers.tabs.pricing.read,
        id: '6',
      },
      {
        path: ADMIN_ROUTES.suppliers.management,
        label: 'Management',
        permission: PERMISSIONS.suppliers.tabs.management.read,
        id: '7',
      },
      {
        path: ADMIN_ROUTES.suppliers.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.suppliers.tabs.attachment.read,
        id: '8',
      },
      {
        path: ADMIN_ROUTES.suppliers.logs,
        label: 'Logs',
        permission: PERMISSIONS.suppliers.tabs.logs.read,
        id: '9',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
